// Vendor libraries
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
// Utils / Constants
import { ICON_BROWSE } from '../../base-autocomplete/base-autocomplete.constants';
// Services
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
// Components
import { AutocompleteInPlaceDirective } from '../autocomplete-in-place.directive';
import { MetricSelectorModalDirective } from 'CalculationsApp/ts/features/metric-selector-modal/components/metric-selector-modal/metric-selector-modal.directive';
import * as i0 from "@angular/core";
import * as i1 from "CalculationsApp/ts/services/calculations.service";
import * as i2 from "../../base-autocomplete/components/base-autocomplete.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../calculations/static/calculations/ts/features/metric-selector-modal/components/single-metric-selector-modal/single-metric-selector-modal.component";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["singleMetricSelectorModal"];
const _c1 = a0 => ({ "is-editing": a0 });
function MetricAutocompleteInPlaceComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function MetricAutocompleteInPlaceComponent_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.edit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipTitle", ctx_r2.tooltipText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
} }
function MetricAutocompleteInPlaceComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12)(1, "a", 13);
    i0.ɵɵlistener("click", function MetricAutocompleteInPlaceComponent_span_7_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.cancel()); });
    i0.ɵɵtext(2, " Cancel ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r2.displayValue);
} }
/**
 *
 * Metric Autocomplete In Place Component
 *
 * Input:
 *   displayIdentifier: The metric ID used to fetch the name from the backend.
 *   inputDisabled: whether the user should be able to change the selected metric.
 *
 * Output:
 *   submitModalHandler: An event emitter that emits the metric selected from the metric modal.
 */
export class MetricAutocompleteInPlaceComponent extends AutocompleteInPlaceDirective {
    constructor(changeDetector, calculationsService) {
        super(changeDetector);
        this.calculationsService = calculationsService;
        this.inputDisabled = false;
        this.submitModalHandler = new EventEmitter();
        this.buttonType = ICON_BROWSE;
        this.isEditing = false;
    }
    /**
     * Display and handle an object selected from the single metric selector modal
     * @param object: The metric object selected from the single metric selector modal
     */
    displayAndHandleModalObject(object) {
        if (object !== undefined) {
            this.displayValue = object.label;
            this.isEditing = false;
            this.submitModalHandler.emit(object);
        }
    }
    setDisplayValue() {
        /**
         * If a new metric ID was set, use the `calculationsService` to get the metric name.
         * If the selected object does not exist in the backend, reset the autocompleter.
         */
        if (!this.displayIdentifier) {
            this.reset();
            return;
        }
        this.calculationsService.getCalcInfo([this.displayIdentifier]).subscribe({
            next: (calcInfo) => {
                if (Object.keys(calcInfo).length)
                    this.displayValue = calcInfo[this.displayIdentifier].label;
                // If there is a displayValue, change the css to show it
                this.isEditing = !this.displayValue;
            },
            error: () => {
                // If no metric with this id exists, reset the autocompleter
                this.reset();
            },
        });
    }
    /**
     * Event handlers
     */
    handleBrowseClick() {
        this.singleSelectMetricModal.openModal();
    }
}
MetricAutocompleteInPlaceComponent.ɵfac = function MetricAutocompleteInPlaceComponent_Factory(t) { return new (t || MetricAutocompleteInPlaceComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.CalculationsService)); };
MetricAutocompleteInPlaceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MetricAutocompleteInPlaceComponent, selectors: [["ycn-metric-autocomplete-in-place"]], viewQuery: function MetricAutocompleteInPlaceComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleSelectMetricModal = _t.first);
    } }, inputs: { displayIdentifier: "displayIdentifier", inputDisabled: "inputDisabled" }, outputs: { submitModalHandler: "submitModalHandler" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 10, vars: 13, consts: [["autocompleteComponent", ""], ["singleMetricSelectorModal", ""], ["ycnDisabled", "", 1, "form-group-editable", 3, "disabled", "ngClass"], [1, "form-value"], [3, "textContent"], ["class", "btn btn-circle btn-transparent btn-edit", "ycnTooltip", "", 3, "tooltipTitle", "click", 4, "ngIf"], [1, "input-group"], [1, "input-group", "field-input-group", 3, "blurHandler", "browseClickHandler", "submitHandler", "appendToBody", "buttonType", "placeholder", "searchType", "searchBlockRegex"], ["class", "input-group-btn", 4, "ngIf"], [3, "submitModalHandler", "submitModalAutocompleteHandler", "searchType"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "input-group-btn"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", 3, "click", "hidden"]], template: function MetricAutocompleteInPlaceComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵelement(2, "div", 4);
        i0.ɵɵtemplate(3, MetricAutocompleteInPlaceComponent_div_3_Template, 2, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 6)(5, "ycn-base-autocomplete", 7, 0);
        i0.ɵɵlistener("blurHandler", function MetricAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_blurHandler_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.blurHandler()); })("browseClickHandler", function MetricAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_browseClickHandler_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleBrowseClick()); })("submitHandler", function MetricAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_submitHandler_5_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.displayAndHandleObject($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, MetricAutocompleteInPlaceComponent_span_7_Template, 3, 1, "span", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "ycn-single-metric-selector-modal", 9, 1);
        i0.ɵɵlistener("submitModalHandler", function MetricAutocompleteInPlaceComponent_Template_ycn_single_metric_selector_modal_submitModalHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.displayAndHandleModalObject($event)); })("submitModalAutocompleteHandler", function MetricAutocompleteInPlaceComponent_Template_ycn_single_metric_selector_modal_submitModalAutocompleteHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.displayAndHandleObject($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.inputDisabled)("ngClass", i0.ɵɵpureFunction1(11, _c1, ctx.isEditing));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", ctx.displayValue);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.inputDisabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("appendToBody", ctx.appendToBody)("buttonType", ctx.buttonType)("placeholder", ctx.placeholder)("searchType", ctx.searchType)("searchBlockRegex", ctx.searchBlockRegex);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hideCancelButton);
        i0.ɵɵadvance();
        i0.ɵɵproperty("searchType", ctx.searchType);
    } }, dependencies: [i2.BaseAutocompleteComponent, i3.NgClass, i3.NgIf, i4.DisabledDirective, i5.IconDirective, i6.SingleMetricSelectorModalComponent, i7.TooltipDirective], encapsulation: 2 });
